import type React from 'react';
import { Select as MantineSelect } from '@mantine/core';
import type { SelectProps as MantineSelectProps } from '@mantine/core';
import './Select.css';

export interface SelectProps extends Omit<MantineSelectProps, 'error' | 'onChange' | 'value'> {
    error?: string;
    value?: string | number | null;
    /** Числовые строки конвертируются в number, остальные значения передаются как есть */
    onChange?: (value: string | number | null) => void;
    /** Алиас для Mantine `nothingFoundMessage` — не передаём в DOM */
    nothingFound?: React.ReactNode;
}

export default function Select({
    error,
    className = '',
    value,
    onChange,
    nothingFound,
    nothingFoundMessage,
    comboboxProps,
    ...restProps
}: SelectProps) {
    const selectClass = `select ${error ? 'select--error' : ''} ${className}`.trim();

    const handleChange = (selectedValue: string | null) => {
        if (!onChange) return;
        if (selectedValue === null) {
            onChange(null);
            return;
        }
        const num = Number(selectedValue);
        onChange(Number.isNaN(num) ? selectedValue : num);
    };

    return (
        <div className="select-wrapper">
            <MantineSelect
                className={selectClass}
                value={value?.toString() ?? null}
                onChange={handleChange}
                comboboxProps={{ zIndex: 1100, ...comboboxProps }}
                {...restProps}
                nothingFoundMessage={nothingFoundMessage ?? nothingFound}
                error={error}
            />
        </div>
    );
}

